<template>
    <div ref="popover" :class="this.class">
        <slot></slot>
    </div>
</template>

<script>
import {Popover} from "bootstrap";

export default {
    name: 'VPopover',
    props: {
        class: {
            type: String,
            required: false,
            default: '',
        },
        content: {
            type: String,
            required: false,
            default: 'Content',
        },
        title: {
            type: String,
            required: false,
            default: 'Title',
        },
        trigger: {
            type: String,
            required: false,
            default: 'hover',
        },
        delay: {
            type: Number,
            default: 0,
        },
        placement: {
            type: String,
            required: false,
            default: 'bottom'
        },
        html: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        let options = this.$props;
        new Popover(this.$refs.popover, options);
    },
};
</script>
